module.exports = __webpack_public_path__ + "img/qr-panel.63014dee.webp";